import { formatDateTime } from '@/utils/formatters';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Tag } from 'antd';

const ROLE_LABELS = {
  administrator: 'Administrator',
  user: 'Standard',
};

const ROLE_COLORS = {
  administrator: 'blue',
  user: 'green',
};

export const getUserTableColumns = ({ onEditUser, onDeleteUser, timezone }) => [
  {
    title: 'First Name',
    dataIndex: 'firstName',
    key: 'firstName',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
    key: 'lastName',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
  },
  {
    title: 'Roles',
    dataIndex: 'roles',
    key: 'roles',
    align: 'center',
    render: (roles) =>
      roles?.map((role) => (
        <Tag key={role} color={ROLE_COLORS[role] || 'default'}>
          {ROLE_LABELS[role] || role}
        </Tag>
      )),
  },
  {
    title: 'Last Login',
    dataIndex: 'lastLogin',
    key: 'lastLogin',
    align: 'center',
    render: (value) => formatDateTime(value, timezone),
  },
  {
    title: 'Action',
    key: 'action',
    align: 'center',
    width: 150,
    render: (_, record) => (
      <Space size="small">
        <Button
          variant="dashed"
          color="primary"
          size="small"
          shape="circle"
          icon={<EditOutlined />}
          onClick={() => onEditUser(record)}
        />
        <Button
          variant="dashed"
          color="danger"
          size="small"
          shape="circle"
          icon={<DeleteOutlined />}
          onClick={() => onDeleteUser(record)}
        />
      </Space>
    ),
  },
];
